import produce from "immer";
import cloneDeep from "lodash/cloneDeep";
import { CustomizationState } from "../../";
import { ContentPageConfiguration } from "../../../../types/customization/template";
import { LocalizedContent } from "../../../../types/customization/text";
import { findPageDefinition } from "../../../../utils/customization/finders";

export interface SetPageConfigMappingAction {
  type: "setPageConfigMapping";
  configuration: ContentPageConfiguration;
}

export function setPageConfigMapping(
  state: CustomizationState,
  action: SetPageConfigMappingAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { content, template } = draftState;
    const configuration = action.configuration;

    const forcedLayoutsDescriptions = cloneDeep(configuration);

    draftState.ui.pagesConfigMapping = content.pages.map((page) => {
      const pageDefinition = findPageDefinition(page.pageDefinitionKey, template);
      const { forced, localizedDescription, position } = getDescriptionByFilterType(
        pageDefinition.filterType,
        forcedLayoutsDescriptions
      );
      const pageDescription = localizedDescription.length > 0 ? localizedDescription : null;

      forcedLayoutsDescriptions.forcedLayouts.splice(position, 1); // remove description from list : it should be used once

      return { pageKey: page.key, description: pageDescription, isForced: forced };
    });
  });
}

export function getDescriptionByFilterType(
  filterType: string,
  contentPageConfiguration: ContentPageConfiguration
): { position: number; localizedDescription: LocalizedContent[]; forced: boolean } {
  let forced = false;
  const forcedDescriptions = contentPageConfiguration.forcedLayouts.filter(
    (forcedLayout) => forcedLayout.description.length > 0
  );
  if (
    forcedDescriptions.length === 0 &&
    contentPageConfiguration.addNext.description.length === 0
  ) {
    return { position: -1, localizedDescription: [], forced };
  }

  let localizedDescriptions: LocalizedContent[] = [];
  const forcedDescriptionIndex = forcedDescriptions.findIndex(
    (description) => description.filterType === filterType
  );

  if (forcedDescriptionIndex > -1) {
    forced = true;
    localizedDescriptions = forcedDescriptions[forcedDescriptionIndex].description;
  } else if (contentPageConfiguration.addNext.filterType === filterType) {
    forced = false;
    localizedDescriptions = contentPageConfiguration.addNext.description;
  }

  return {
    forced,
    localizedDescription: localizedDescriptions,
    position: forcedDescriptionIndex,
  };
}
